import { initial } from 'lodash';
import Swiper from 'swiper/bundle';

common.View.create('canvas.blocks.custom.header.Block', {
    
    onDOMLoad() {
        this.initSwiperHeader();
    },

    initSwiperHeader() {
        let activeIndex = 0;

        // let headerImageSwiperContainer = this.element.find('.headerImageSwiper .swiper-wrapper-header-image').get(0);
        let isNotEditing = this.element.find('.headerImageSwiper').data('is-not-editing');
        let isEditing = this.element.find('.headerImageSwiper').data('is-editing');
        let swiperSlideCount = this.element.find('.headerTextSwiper .swiper-wrapper-header-text .swiper-slide').length;

        const headerTextSwiperConfigBase = {
            slidesPerView: Math.min(swiperSlideCount || 3),
            allowTouchMove: false,
            keyboard: false,
            mousewheel: true,
            initialSlide: 0,
            wrapperClass: 'swiper-wrapper-header-text',
        };

        const headerTextSwiperConfigEnhanced = {
            slidesPerView: Math.min(swiperSlideCount || 3),
            allowTouchMove: false,
            keyboard: false,
            mousewheel: false,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            initialSlide: 0,
            wrapperClass: 'swiper-wrapper-header-text',
            on: {
                autoplayTimeLeft(s, time, progress) {
                    const activeSlide = s.slides[s.activeIndex]; // Ensure correct active slide
                    const maskedText = document.querySelector(`.masked-text-${activeIndex}`);
                
                    if (maskedText) {
                        // Dynamically update the CSS variable for the pseudo-element width
                        maskedText.style.setProperty('--mask-width', `${(1 - progress) * 100}%`);
                    }
                
                    if (progress <= 0) {
                        s.autoplay.stop();
                
                        if (maskedText) {
                            maskedText.style.setProperty('--mask-width', `0%`); // Reset text mask
                        }
                
                        activeIndex = (activeIndex + 1) % swiperSlideCount;
                
                        if (activeIndex === 0) {
                            s.slideTo(0);
                            headerImageSwiper.slideTo(0);
                            textSwiper.slideTo(0);
                        } else {
                            s.slideNext();
                            headerImageSwiper.slideNext();
                            textSwiper.slideNext();
                        }
                
                        s.autoplay.start();
                    }
                },
            }
        };

        const headerTextSwiperConfig = isEditing ? headerTextSwiperConfigBase : headerTextSwiperConfigEnhanced;
        const headerTextSwiper = new Swiper('.headerTextSwiper', headerTextSwiperConfig);

        const headerImageSwiperConfigBase = {
            slidesPerView: 1,
            allowTouchMove: true,
            keyboard: false,
            mousewheel: false,
            initialSlide: 0,
            wrapperClass: 'swiper-wrapper-header-image',
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        };

        const headerImageSwiperConfigEnhanced = {
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            slidesPerView: 1,
            // loop: true,
            allowTouchMove: false,
            keyboard: false,
            mousewheel: false,
            wrapperClass: 'swiper-wrapper-header-image',
            // loopAdditionalSlides: swiperSlideCount || 3
        };

        const headerImageSwiperConfig = isEditing ? headerImageSwiperConfigBase : headerImageSwiperConfigEnhanced;
        const headerImageSwiper = new Swiper('.headerImageSwiper', headerImageSwiperConfig);

        const textSwiperConfigBase = {
            slidesPerView: 1,
            // loop: true,
            allowTouchMove: false,
            initialSlide: 0,
            keyboard: false,
            mousewheel: false,
            wrapperClass: 'swiper-wrapper-text',
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        };

        const textSwiperConfigEnhanced = {
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            slidesPerView: 1,
            // loop: true,
            allowTouchMove: false,
            initialSlide: 0,
            keyboard: false,
            mousewheel: false,
            wrapperClass: 'swiper-wrapper-text'
        };

        const textSwiperConfig = isEditing ? textSwiperConfigBase : textSwiperConfigEnhanced;
        const textSwiper = new Swiper('.textSwiper', textSwiperConfig);

        if(isNotEditing) {
            // headerImageSwiper.slides.forEach((slide, index) => {
            //     let clone = slide.cloneNode(true);
            //     headerImageSwiperContainer.appendChild(clone);
            // });

            // headerTextSwiper.controller.control = headerImageSwiper;

            headerTextSwiper.slides.forEach((slide, index) => {
                slide.addEventListener('click', () => {
                    headerTextSwiper.autoplay.stop();

                    const maskedText = document.querySelector(`.masked-text-${activeIndex}`);
                
                    if (maskedText) {
                        maskedText.style.setProperty('--mask-width', `0%`); // Reset text mask
                    }
                    
                    activeIndex = index;

                    headerTextSwiper.slideTo(activeIndex);
                    headerImageSwiper.slideTo(activeIndex);
                    textSwiper.slideTo(activeIndex);
                    headerTextSwiper.autoplay.start();
                });
            });
        }
    },
});
